const colors = {
    font: '#222326',
    black: '#292929',
    gray: '#BFBEBE'
}

export default colors;
